import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { getRandomFact } from '@shared/constants/loading-facts';

const CYCLE_MS = 15000; // 15 seconds per fact

export function LoadingFacts() {
  const [currentFact, setCurrentFact] = useState(() => getRandomFact());
  const shownIndices = useRef(new Set<number>([currentFact.index]));

  useEffect(() => {
    const interval = setInterval(() => {
      const next = getRandomFact(shownIndices.current);
      shownIndices.current.add(next.index);
      setCurrentFact(next);
    }, CYCLE_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="max-w-lg mx-auto mt-8 px-4">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentFact.index}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          className="text-center"
        >
          <div className="flex items-start gap-3 text-left">
            <Lightbulb size={18} className="text-gold-500 shrink-0 mt-0.5" />
            <p className="text-sm text-content font-body leading-relaxed italic">
              {currentFact.fact}
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
